import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toggleSecondModalClose, toggleModal } from '../../../storage/actions/modalsActions';
import getContractorDetails from '../../../utils/api/get/getContractorDetails';
import DashboardModalLoader from '../../dashboard/common/DashboardModalLoader';
import Content from './Content';

const ContractorDetailsModal = ({
  modalState,
  profile,
  toggleSecondModalClose,
  toggleModal,
}) => {
  const [contractorDetails, setContractorDetails] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const contentRef = useRef(null);


  useEffect(() => {
    if (!modalState?.type.contractorId) return;

    let isMounted = true;

    const fetchContractorDetails = async () => {
      const data = await getContractorDetails(modalState.type?.contractorId);
      if (!isMounted) return;
      setContractorDetails(data);
      setIsLoaded(true);
    };

    fetchContractorDetails();
    return () => { isMounted = false; };
  }, [modalState?.type?.contractorId]);


  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [isLoaded]);

  const closeModal = () => {
    toggleSecondModalClose('contractorDetailsModal', true);
  };

  if (!modalState?.isOpen) return null;

  return (
    <div className="profile_container">
      <div className="profile_inner opened">
        <div className="profile_head">
          <div className="profile_title">
            {contractorDetails?.name || 'Loading...'}
          </div>
          <button
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>

        <div className="profile_content wurqly-modal-scroll" ref={contentRef}>
          {!isLoaded && <DashboardModalLoader />}
          {isLoaded && (
            <Content
              contractorDetails={contractorDetails}
              profile={profile}
              toggleModal={toggleModal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.contractorDetailsModal,
  profile: state.profile,
});

const mapDispatchToProps = {
  toggleSecondModalClose,
  toggleModal
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContractorDetailsModal));